import { marketplaceApiVersionPrefix } from '../client'

export function toCustomerIri(customerUuid: string): string {
  const customerIri = `${marketplaceApiVersionPrefix}/shop/profiles/${customerUuid}`
  return customerIri
}
